import * as Yup from 'yup'

const AddPost = Yup.object().shape({
  title: Yup.string().required('Please enter title'),
  type: Yup.string().required('Please enter type'),
})

// eslint-disable-next-line import/no-anonymous-default-export
export default { AddPost }
